import DateItem from './DateItem';
import IconButton from 'src/components/Buttons/IconButton';
import moment from '../../../../utils/moment';
import months from 'src/constants/months';
import React, { useCallback } from 'react';
import SVG from 'src/components/Images/SvgRenderer';
import useStyles from './style';
import { calendarViewModes } from 'src/utils/useCalendar';
import { CircularProgress } from '@mui/material';
import { getUserRole, getUserSetting } from 'src/utils/useUser';
import { moveLastToFirstInArray } from 'src/utils/useFunctions';
import { setCalendarDate, setCalendarViewMode } from 'src/store/actions/calendar.actions';
import { setCalendarEventHandleModal } from 'src/store/actions/modals.actions';
import { useAppDispatch, useAppSelector } from 'src/hooks/redux-hooks';
import { useTranslation } from 'react-i18next';
import { weekdaysMin } from '../../../../constants/weekdays';

type CalendarYearType = {
  className?: any;
};

const CalendarYear: React.FunctionComponent<CalendarYearType> = ({ className }) => {

  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const classes = useStyles();
  const calendarData = useAppSelector((state: any) => state.calendar);
  const userData = useAppSelector((state: any) => state.user);

  const curDate = calendarData.date;
  const isLoading = calendarData.isLoading;

  const firstDayInWeek = getUserSetting(userData.userSettings, "customizations", ["calendar", "first_day_in_week"]);

  const weekdays: any = firstDayInWeek === 0 ? moveLastToFirstInArray(weekdaysMin) : weekdaysMin;

  const getFirstDate = useCallback((month: any) => {
    const startOfMonth = moment(curDate).set('month', month).date(0);
    return moment(startOfMonth).subtract(moment(startOfMonth).day(), 'days');
  }, [curDate]);

  const handleAddEvent = (e: any, month: any) => {
    e.preventDefault();
    e.stopPropagation();
    const settings = {
      isOpen: true,
      date: moment().set('month', month).set('year', moment(curDate).year()).startOf('month'),
      dateTime: null,
      eventID: null,
    };
    dispatch(setCalendarEventHandleModal(settings));
  };

  const handleSetMonth = (month: any) => {
    dispatch(setCalendarDate(moment(curDate).set('month', month)));
    dispatch(setCalendarViewMode(calendarViewModes[2]));
  };
  
  return (
    <div className={`${classes.calendarYear} ${className ? className : null}`}>
      <div className={classes.months}>
        {
          months.map((item: any, key: any) => {
            const firstDate = getFirstDate(key);
            return (
              <div className={classes.month} key={`k_${key}`}>
                <div className={classes.monthHeader}>
                  <span onClick={() => handleSetMonth(key)}>{t(item.toLowerCase())}</span>
                  {
                    getUserRole(userData.userObject.roleType) === "director" ? (
                      <IconButton size="medium" onClick={(e: any) => handleAddEvent(e, key)}>
                        <SVG src="plus"/>
                      </IconButton>
                    ) : null
                  }
                </div>
                <div className={classes.weekdayHeader}>
                {
                  weekdays.map((weekday: any, key: any) => (
                    <div className={classes.weekday} key={`k_${key}`}>
                      <p>{t(weekday[0].toLowerCase() + weekday.slice(1))}</p>
                    </div>
                  ))
                }
                </div>
                <div className={classes.days}>
                  {
                    isLoading ? (
                      <div className={classes.loadingWrapper}>
                        <div className={classes.spinner}>
                          <CircularProgress/>
                        </div>
                      </div>
                    ) : null
                  }
                  {
                    firstDate && new Array(42).fill('').map((_, key) => {
                      return (
                        <DateItem
                          index={key}
                          key={`k_${key}`}
                          date={moment(firstDate).add(key + firstDayInWeek, 'days')}
                        />
                      );
                    })
                  }
                </div>
              </div>
            );
          })
        }
      </div>
    </div>
  );
};

export default CalendarYear;